import { d as i } from "./define-built-in.js";
var n = function n(_n, r, e) {
  for (var t in r) i(_n, t, r[t], e);
  return _n;
};
export { n as d };